export default __webpack_public_path__ + "static/media/6D.8c9d26ce.svg";